import React, { useEffect, useState } from "react";
import { Col, Dropdown, Modal, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { moduleForm } from "../../../Constant/moduleForm";
import { conditions } from "../../../Constant/moduleForm";
import { editConditions } from "../../../Constant/moduleForm";
import { useDispatch, useSelector } from "react-redux";
import { getModuleByIdStart } from "../../../Store/Slices/formSlice";
import { createWorkflowStart, getWorkflowByIdStart, getWorkflowModuleStart, getWorkflowStart, updateWorkflowStart } from "../../../Store/Slices/workflowSlice";
import { FaPencil } from "react-icons/fa6";
import Select, { components } from 'react-select';
import { toast } from "react-toastify";
import Toast from "../../../Components/Toast";
import { getAllUserDataStart } from "../../../Store/Slices/userSlice";
import { Utils } from "../../../Utils";
import Loader from "../../../Components/Loader";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a

        className='dropdown-item'
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <span className='ms-2'>&#128898;</span>
    </a>
));

const CreateWorkflow = () => {
    const location = useLocation();
    let currentOrg = useSelector((state) => state?.org);
    let getAllUsers = useSelector((state) => state?.user);
    // console.log('all user?', getAllUsers)
    let moduleList = useSelector((state) => state?.forms)?.navbarList;
    let formList = useSelector((state) => state?.forms?.modules);
    // console.log('frm list?', formList)

    const { id } = useParams();
    const isEdit = Boolean(id);
    // console.log('is edit?', isEdit)

    let data = null;
    let module_id = null;
    let module_name = null;

    data = location?.state;
    // console.log('data?????', data)
    module_id = data?.module?.split('#')[0];
    module_name = data?.module?.split('#')[1];
    if (isEdit) {
        module_id = data?.moduleId?._id
        module_name = data?.moduleId?.name
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();
    let workflowList = useSelector((state) => state?.workflow);
    let workflowResponse = useSelector((state) => state?.workflow)?.selectedData?.[0];
    let ruleModuleData = useSelector((state) => state?.workflow)?.ruleModuleData;

    const allUsers = useSelector((state) => state?.user);
    const allRoles = useSelector((state) => state?.role);


    const [isShowContact, setIsShowContact] = useState(true);
    const [subOptions, setSubOptions] = useState([]);
    const [showLoader, setShowLoader] = useState(false)

    const [workflowData, setWorkflowData] = useState({
        moduleId: null,
        ruleName: null,
        ruleDescription: null,
        approvalPermission: ['create'],
        approvalUserList: [{
            position: '1',
            userId: '',
            status: 'Approval 1',
            approvalSections: '',
            primaryField: ''
        }],
        rules: {
            workflow_base: null,
            workflow_base_type: 'create',
            workflow_base_create_edit: {
                isRepeatCreateEdit: false
            },
            workflow_base_edit: {
                isRepeatEdit: false,
                type: 'any_field',
                typeSpecificField: {
                    fieldConditions: [{
                        id: '',
                        field: '',
                        type: '',
                        condition: '',
                        value: ''
                    }]
                },
                typeSpecificSection: {
                    layout: 'Standard',
                    sections: ''
                }
            },
            contactType: 'matching_contact',
            conditions: [{
                id: '',
                field: '',
                type: '',
                condition: '',
                value: ''
            }],
            emailData: {
                name: '',
                to: [],
                isSingleMail: false,
                cc: [],
                bcc: []
            }
        }
    });
    const [errors, setErrors] = useState({});
    const [showBcc, isShowBcc] = useState(false)
    const [displayOption, setDisplayOption] = useState({
        create1: true,
        create2: null,
        create3: null,
    });

    const [edit1, setEdit1] = useState(false);
    const [edit2, setEdit2] = useState(false);
    const [fieldList, setFieldList] = useState([]);
    const [sectionsData, setSectionsData] = useState([]);
    const [actionType, setActionType] = useState('');
    const [functionType, setFunctionType] = useState('');
    const [galleryConfigType, setGalleryConfigType] = useState('');
    const [showAddTask, setShowAddTask] = useState(false);
    const [showApprovalUserModal, setShowApprovalUserModal] = useState(false);
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [templateData, setTemplateData] = useState({
        moduleId: '',
        moduleName: '',
        moduleFieldId: '',
        moduleFieldName: ''
    });
    const [emailData, setEmailData] = useState({
        templateName: '',
        subject: '',
        content: '',
        signature: null
    })
    const [showTable, setShowTable] = useState(true)
    const [oldData, setOldData] = useState([]);

    useEffect(() => {
        setOldData(workflowResponse)
    }, [workflowResponse])

    useEffect(() => {
        if (module_id && module_name) {
            setTemplateData((form) => ({
                ...form,
                moduleId: module_id,
                moduleName: module_name
            }));
        }
    }, [module_id, module_name])

    const handleTemplateData = (e) => {
        const { name, value } = e?.target;
        // console.log('target value?', value)
        if (name === 'moduleId') {
            setTemplateData((form) => ({
                ...form,
                [name]: value.split('#')[0],
                moduleName: value.split('#')[1],
                moduleFieldId: '',
                moduleFieldName: ''
            }));
            setFieldList([]);
            dispatch(getModuleByIdStart(value));
        }
        if (name === 'moduleFieldId') {
            // console.log('content?', emailData.content)

            setTemplateData((form) => ({
                ...form,
                [name]: value.split('#')[0],
                moduleFieldName: value.split('#')[1]
            }));

            setEmailData((form) => ({
                ...form,
                content: form.content + '${' + templateData.moduleName + '.' + value.split('#')[1] + '}'
            }));
        }
    }

    const handleEmailData = (e) => {
        const { name, value } = e?.target;
        if (name === 'content') {
            setEmailData((form) => ({
                ...form,
                [name]: value
            }));
        } else {
            setEmailData((form) => ({
                ...form,
                [name]: value
            }));
        }
    }

    const onSelectFile = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        // let formData = new FormData();
        // formData.append('file', file);
        setEmailData((data) => ({
            ...data,
            signature: URL.createObjectURL(e.target.files[0])
        }));
    };

    const resetTemplate = () => {
        setTemplateData((form) => ({
            ...form,
            moduleId: module_id ? module_id : '',
            moduleName: module_name ? module_name : '',
            moduleFieldId: '',
            moduleFieldName: ''
        }));
        setEmailData((form) => ({
            ...form,
            templateName: '',
            subject: '',
            content: '',
            signature: null
        }));
    }

    useEffect(() => {
        if (formList?.length > 0) {
            setFieldList([]);
            let sections = formList?.[0]?.fields?.sections;
            setSectionsData(sections.map(option => option.section_name && {
                label: option.section_name,
                value: option.section_name
            }))

            for (var i = 0; i < sections.length; i++) {
                if (sections[i].dropped_list) {
                    let list = sections[i].dropped_list
                    let o_val = Object.values(list)
                    for (var j = 0; j < o_val.length; j++) {
                        for (var k = 0; k < o_val[j].length; k++) {
                            let _value = o_val[j][k];
                            setFieldList(list => [...list, _value])
                        }
                    }
                }
            }
        }
        // console.log('field list?', fieldList)
    }, [formList])

    useEffect(() => {
        if (!isEdit) {
            dispatch(getModuleByIdStart(module_id));
            dispatch(getWorkflowModuleStart(module_id));
            setWorkflowData((form) => ({
                ...form,
                moduleId: module_id,
            }));
        } else {
            data = workflowResponse;
            // module_id = workflowResponse?.moduleId?._id;
            // module_name = workflowResponse?.moduleId?.name;
            setWorkflowData((form) => ({
                ...form,
                moduleId: module_id,
            }));
            dispatch(getModuleByIdStart(module_id));
            dispatch(getWorkflowModuleStart(module_id));
        }
        dispatch(getWorkflowStart());
        // dispatch(getWorkflowModuleStart());
        dispatch(getAllUserDataStart());
    }, []);

    // EDIT START

    useEffect(() => {
        if (isEdit) {
            dispatch(getWorkflowByIdStart(id));
        }
    }, [id, isEdit]);

    useEffect(() => {
        if (data) {
            setWorkflowData((prev) => ({
                ...prev,
                ruleName: data?.ruleName,
                ruleDescription: data?.ruleDescription,
            }));
        }
    }, [data])

    useEffect(() => {
        if (id && isEdit) {
            if (!workflowResponse)
                setShowLoader(true)
            else {
                setWorkflowData((prev) => ({
                    ...prev,
                    moduleId: workflowResponse?.moduleId?._id,
                    ruleName: workflowResponse?.ruleName,
                    ruleDescription: workflowResponse?.ruleDescription,
                    rules: {
                        ...prev.rules,
                        workflow_base: workflowResponse?.rules?.workflow_base,
                        workflow_base_type: workflowResponse?.rules?.workflow_base_type,
                        contactType: workflowResponse?.rules?.contactType,
                        conditions: workflowResponse?.rules?.conditions
                    },
                    approvalUserList: workflowResponse?.approvalUserList
                }));
                if (workflowResponse?.rules?.workflow_base_type === 'create_edit') {
                    setWorkflowData((prev) => ({
                        ...prev,
                        rules: {
                            ...prev.rules,
                            workflow_base_create_edit: {
                                ...prev.rules.workflow_base_create_edit,
                                isRepeatCreateEdit: workflowResponse.rules.workflow_base_create_edit.isRepeatCreateEdit
                            }
                        }
                    }));
                }
                if (workflowResponse?.rules?.workflow_base_type === 'edit') {
                    setWorkflowData((prev) => ({
                        ...prev,
                        rules: {
                            ...prev.rules,
                            workflow_base_edit: {
                                ...prev.rules.workflow_base_edit,
                                isRepeatEdit: workflowResponse.rules.workflow_base_edit.isRepeatEdit,
                                type: workflowResponse.rules.workflow_base_edit.type,
                            }
                        }
                    }));
                    if (workflowResponse?.rules?.workflow_base_edit?.type === 'specific_section') {
                        setWorkflowData((prev) => ({
                            ...prev,
                            rules: {
                                ...prev.rules,
                                workflow_base_edit: {
                                    ...prev.rules.workflow_base_edit,
                                    typeSpecificSection: {
                                        ...prev.rules.workflow_base_edit.typeSpecificSection,
                                        layout: workflowResponse.rules.workflow_base_edit.typeSpecificSection.layout,
                                        sections: workflowResponse.rules.workflow_base_edit.typeSpecificSection.sections
                                    }
                                }
                            }
                        }));
                    }
                    if (workflowResponse?.rules?.workflow_base_edit?.type === 'specific_field') {
                        setWorkflowData((prev) => ({
                            ...prev,
                            rules: {
                                ...prev.rules,
                                workflow_base_edit: {
                                    ...prev.rules.workflow_base_edit,
                                    typeSpecificField: {
                                        ...prev.rules.workflow_base_edit.typeSpecificField,
                                        fieldConditions: workflowResponse.rules.workflow_base_edit.typeSpecificField.fieldConditions
                                    }
                                }
                            }
                        }));
                    }
                }
                setDisplayOption({ create1: true, create2: true, create3: true });
                setShowLoader(false)
            }
        } else {
            setShowTable(false)
        }
    }, [workflowResponse])

    useEffect(() => {
        if (id && isEdit) {
            const selected = moduleForm[0].rule_base_options.find(
                (option) => option.value === workflowData.rules.workflow_base
            );
            if (selected?.subOptions) {
                setSubOptions(selected.subOptions);
            } else {
                setSubOptions([]);
            }
        }

    }, [workflowData.rules.workflow_base])


    // EDIT END

    const isBaseCardComplete = workflowData?.rules?.workflow_base && workflowData?.rules?.workflow_base_type;

    const formHandler = (e) => {
        try {
            const { name, value } = e?.target
            setWorkflowData((prev) => ({
                ...prev,
                rules: {
                    ...prev.rules,
                    [e?.target?.name]: e?.target?.value
                }
            }))
            if (e.target.name == 'workflow_base') {
                const selected = moduleForm[0].rule_base_options.find(
                    (option) => option.value === e.target.value
                );
                if (selected?.subOptions) {
                    setSubOptions(selected.subOptions);
                } else {
                    setSubOptions([]);
                }
            }

            if (e.target.name == 'workflow_base_type') {
                setWorkflowData((form) => ({
                    ...form,
                    approvalPermission: (e?.target?.value).split("_")
                }))
            }

            if (e.target.name == 'contactType' && e.target.value == 'matching_contact') {
                setIsShowContact(true);
                setWorkflowData((form) => ({
                    ...form,
                    rules: {
                        ...form.rules,
                        conditions: [{
                            field: '',
                            condition: '',
                            value: ''
                        }]
                    }
                }))
            } else if (e.target.name == 'contactType' && e.target.value == 'all_contact') {
                setIsShowContact(false);
                setWorkflowData((form) => ({
                    ...form,
                    rules: {
                        ...form.rules,
                        conditions: 'all_contacts'
                    }
                }))
            }

            if (e.target.name == 'type') {
                setWorkflowData((form) => ({
                    ...form,
                    rules: {
                        ...form.rules,
                        workflow_base_edit: {
                            ...form.rules.workflow_base_edit,
                            type: e.target.value
                        }
                    }
                }))
            }

            if (name === 'isRepeatCreateEdit') {
                setWorkflowData((form) => ({
                    ...form,
                    rules: {
                        ...form.rules,
                        workflow_base_create_edit: {
                            ...form.rules.workflow_base_create_edit,
                            isRepeatCreateEdit: e?.target?.checked
                        }
                    }
                }))
            }
            if (name === 'isRepeatEdit') {
                setWorkflowData((form) => ({
                    ...form,
                    rules: {
                        ...form.rules,
                        workflow_base_edit: {
                            ...form.rules.workflow_base_edit,
                            isRepeatEdit: e?.target?.checked
                        }
                    }
                }))
            }

            // if (e.target.name === 'typeSpecificSection') {
            // const formApprovalSectionHandler = (item, index) => {
            //     try {
            // setWorkflowData((prevstate) => {
            //     const updatedCondition = prevstate.approvalUserList.map((user, rowIndex) =>
            //         rowIndex === index ? {
            //             ...user,
            //             approvalSections: item
            //         } : user
            //     );
            //     return {
            //         ...prevstate,
            //         approvalUserList: updatedCondition
            //     };
            // });
            //     } catch (err) {
            //         throw err;
            //     }
            // }

            if (e.target.name === 'sections') {
                setWorkflowData((form) => ({
                    ...form,
                    rules: {
                        ...form.rules,
                        workflow_base_edit: {
                            ...form.rules.workflow_base_edit,
                            typeSpecificSection: {
                                ...form.rules.workflow_base_edit.typeSpecificSection,
                                layout: 'Standard',
                                sections: e.target.value
                                // sections: [...form.rules.workflow_base_edit.typeSpecificSection, e.target.value]
                            }
                        }
                    }
                }))
            }

        } catch (err) {
            throw err;
        }
    }

    const editFormConditionHandler = (e, index) => {
        try {
            if (e?.target?.name !== 'field') {
                setWorkflowData((prev) => ({
                    ...prev,
                    rules: {
                        ...prev.rules,
                        workflow_base_edit: {
                            ...prev.rules.workflow_base_edit,
                            typeSpecificField: {
                                ...prev.rules.workflow_base_edit.typeSpecificField,
                                fieldConditions: prev.rules.workflow_base_edit.typeSpecificField.fieldConditions.map((condition, i) =>
                                    i === index ? {
                                        ...condition,
                                        [e?.target?.name]: e?.target?.value
                                    } : condition
                                )
                            }
                        }
                    },
                }));
            } else {
                let id = e?.target?.value.split('#')[0];
                // let field = e?.target?.value.split('#')[1]
                let type = e?.target?.value.split('#')[2];
                setWorkflowData((prev) => ({
                    ...prev,
                    rules: {
                        ...prev.rules,
                        workflow_base_edit: {
                            ...prev.rules.workflow_base_edit,
                            typeSpecificField: {
                                ...prev.rules.workflow_base_edit.typeSpecificField,
                                fieldConditions: prev.rules.workflow_base_edit.typeSpecificField.fieldConditions.map((condition, i) =>
                                    i === index ? {
                                        ...condition,
                                        [e?.target?.name]: e?.target?.value,
                                        type: type,
                                        id: id,
                                        value: '',
                                        condition: ''
                                    } : condition
                                )
                            }
                        }
                    },
                }));
            }

        } catch (err) {
            throw err;
        }
    }

    const handleEditAddField = () => {
        const newItem = {
            field: '',
            condition: '',
            value: ''
        }
        setWorkflowData((prev) => ({
            ...prev,
            rules: {
                ...prev.rules,
                workflow_base_edit: {
                    ...prev.rules.workflow_base_edit,
                    typeSpecificField: {
                        ...prev.rules.workflow_base_edit.typeSpecificField,
                        fieldConditions: [...prev.rules.workflow_base_edit.typeSpecificField.fieldConditions, newItem]
                    }
                }
            },
        }));
    }

    const handleEditRemoveField = (index) => {
        if (workflowData.rules.workflow_base_edit.typeSpecificField.fieldConditions.length > 1) {
            setWorkflowData((prev) => ({
                ...prev,
                rules: {
                    ...prev.rules,
                    workflow_base_edit: {
                        ...prev.rules.workflow_base_edit,
                        typeSpecificField: {
                            ...prev.rules.workflow_base_edit.typeSpecificField,
                            fieldConditions: prev.rules.workflow_base_edit.typeSpecificField.fieldConditions.filter((_, i) => i !== index)
                        }
                    }
                }
            }));
        }
    }


    const formConditionHandler = (e, index) => {
        try {
            if (e?.target?.name !== 'field') {
                setWorkflowData((prevUser) => ({
                    ...prevUser,
                    rules: {
                        ...prevUser.rules,
                        conditions: prevUser.rules.conditions.map((condition, i) =>
                            i === index ? {
                                ...condition,
                                [e?.target?.name]: e?.target?.value
                            } : condition
                        ),
                    },
                }));
            } else {
                let id = e?.target?.value.split('#')[0];
                // let field = e?.target?.value.split('#')[1]
                let type = e?.target?.value.split('#')[2];
                setWorkflowData((prevUser) => ({
                    ...prevUser,
                    rules: {
                        ...prevUser.rules,
                        conditions: prevUser.rules.conditions.map((condition, i) =>
                            i === index ? {
                                ...condition,
                                [e?.target?.name]: e?.target?.value,
                                'type': type,
                                'id': id
                            } : condition
                        ),
                    },
                }));
            }

        } catch (err) {
            throw err;
        }
    }

    const openAction = (type) => {
        if (id && isEdit) {
            setShowApprovalUserModal(true)
        } else {
            if (type === 'approval_user') {
                // for record action
                if (ruleModuleData.length > 0) {
                    let isExistData = ruleModuleData.filter((data) => (
                        data.approvalUserList.length > 0 && data.rules.workflow_base_type === workflowData.rules.workflow_base_type
                    ));
                    if (isExistData.length) {
                        toast.info('Already you have a rule for respective action.', {
                            autoClose: 3000
                        })
                        setShowApprovalUserModal(false)
                    } else {
                        setShowApprovalUserModal(true)
                    }
                } else {
                    setShowApprovalUserModal(true)
                }
            } else {
                setShowApprovalUserModal(true)
            }
        }
    }

    const handleSubmit = () => {
        let userList = workflowData.approvalUserList;
        if (userList.length > 0) {
            if (userList.length == 1) {
                if (userList[0].approvalSections === '' || userList[0].primaryField === '' || userList[0].userId === '') {
                    toast.info('You cannot have a Workflow condition without any action.', {
                        autoClose: 3000
                    })
                    return;
                }
            }
        }
        // e.preventDefault();
        let obj = {
            approvalPermission: workflowData.approvalPermission,
            approvalUserList: workflowData.approvalUserList,
            moduleId: workflowData.moduleId,
            ruleDescription: workflowData.ruleDescription,
            ruleName: workflowData.ruleName,
            rules: {
                conditions: workflowData.rules.conditions,
                contactType: workflowData.rules.contactType,
                workflow_base: workflowData.rules.workflow_base,
                workflow_base_type: workflowData.rules.workflow_base_type,
            }
        }
        if (workflowData.rules.workflow_base_type === 'edit') {
            let editObj = workflowData.rules.workflow_base_edit;
            let newObj = {};
            if (editObj.type === 'any_field') {
                newObj = {
                    isRepeatEdit: editObj.isRepeatEdit,
                    type: editObj.type
                }
            }
            if (editObj.type === 'specific_field') {
                newObj = {
                    isRepeatEdit: editObj.isRepeatEdit,
                    type: editObj.type,
                    typeSpecificField: editObj.typeSpecificField
                }
            }
            if (editObj.type === 'specific_section') {
                newObj = {
                    isRepeatEdit: editObj.isRepeatEdit,
                    type: editObj.type,
                    typeSpecificSection: editObj.typeSpecificSection
                }
            }
            obj.rules['workflow_base_edit'] = newObj
        }
        if (workflowData.rules.workflow_base_type === 'create_edit')
            obj.rules['workflow_base_create_edit'] = workflowData.rules.workflow_base_create_edit

        dispatch(createWorkflowStart(obj));
    };

    const handleUpdate = (e) => {
        setOldData(workflowData);
           
        let obj = {
            approvalPermission: workflowData.approvalPermission,
            approvalUserList: workflowData.approvalUserList,
            moduleId: workflowData.moduleId,
            ruleDescription: workflowData.ruleDescription,
            ruleName: workflowData.ruleName,
            rules: {
                conditions: workflowData.rules.conditions,
                contactType: workflowData.rules.contactType,
                workflow_base: workflowData.rules.workflow_base,
                workflow_base_type: workflowData.rules.workflow_base_type,
            }
        }
        if (workflowData.rules.workflow_base_type === 'edit') {
            let editObj = workflowData.rules.workflow_base_edit;
            let newObj = {};
            if (editObj.type === 'any_field') {
                newObj = {
                    isRepeatEdit: editObj.isRepeatEdit,
                    type: editObj.type
                }
            }
            if (editObj.type === 'specific_field') {
                newObj = {
                    isRepeatEdit: editObj.isRepeatEdit,
                    type: editObj.type,
                    typeSpecificField: editObj.typeSpecificField
                }
            }
            if (editObj.type === 'specific_section') {
                newObj = {
                    isRepeatEdit: editObj.isRepeatEdit,
                    type: editObj.type,
                    typeSpecificSection: editObj.typeSpecificSection
                }
            }
            obj.rules['workflow_base_edit'] = newObj
        }
        if (workflowData.rules.workflow_base_type === 'create_edit')
            obj.rules['workflow_base_create_edit'] = workflowData.rules.workflow_base_create_edit
            
            const newData = obj; 
            const auditLog = Utils.workflowLog(oldData, newData);
            newData.audit_log = { msg: auditLog };
            
        if (id) {
            dispatch(updateWorkflowStart({
                id, payload: obj, auditLog
            }))
        }
    }

    useEffect(() => {
        if (workflowList?.updateStatus || workflowList.createStatus) {
            navigate(Utils.getNavigationUrl('/workflow-rules'))
        }
    }, [workflowList?.updateStatus, workflowList.createStatus]);

    const handleAddField = () => {
        const newItem = {
            field: '',
            condition: '',
            value: ''
        }
        setWorkflowData((prevUser) => ({
            ...prevUser,
            rules: {
                ...prevUser.rules,
                conditions: [...prevUser.rules.conditions, newItem]
            },
        }));
    }

    const handleRemoveField = (index) => {
        if (workflowData.rules.conditions.length > 1)
            setWorkflowData((prev) => ({
                ...prev,
                rules: {
                    ...prev.rules,
                    conditions: prev.rules.conditions.filter((_, i) => i !== index)
                }
            }));
    }

    const handleAddUser = (rowIndex) => {
        let type = typeof workflowData.approvalUserList;
        if (type === 'object') {
            let conditionList = workflowData.approvalUserList;
            if (conditionList.length > 0) {
                if (conditionList[rowIndex].userId === "" || conditionList[rowIndex].approvalSections.length === 0 || conditionList[rowIndex].primaryField === "") {
                    toast.info('Please provide a valid information to proceed.', {
                    });
                    return;
                }
            }
        }
        const newItem = {
            position: '',
            userId: '',
            status: '',
            approvalSections: ''
        }
        setWorkflowData({
            ...workflowData,
            approvalUserList: [...workflowData.approvalUserList, newItem]
        })
    }
    const handleSave = () => {
        let type = typeof workflowData.approvalUserList;
        if (type === 'object') {
            let conditionList = workflowData.approvalUserList;
            if (conditionList.length > 0) {
                for (var i = 0; i < conditionList.length; i++) {
                    if (conditionList[i].userId === "" || conditionList[i].approvalSections.length === 0 || conditionList[i].primaryField === "") {
                        toast.info('Please provide a valid information to proceed.', {
                        });
                        return;
                    }
                }
            }
        }
        setShowTable(true);
        setShowApprovalUserModal(false);
    }

    const formApprovalUserHandler = (e, index) => {
        try {
            setWorkflowData((prevstate) => {
                const updatedCondition = prevstate.approvalUserList.map((user, rowIndex) =>
                    rowIndex === index ? {
                        ...user,
                        [e?.target?.name]: e?.target?.value,
                        position: rowIndex + 1,
                        status: 'Approval ' + (rowIndex + 1),
                        approvalSections: []
                    } : user
                );
                return {
                    ...prevstate,
                    approvalUserList: updatedCondition
                };
            })
        } catch (err) {
            throw err;
        }
    }

    const formSectionHandler = (item) => {
        try {
            // setWorkflowData((form) => ({
            //     ...form,
            //     rules: {
            //         ...form.rules,
            //         workflow_base_edit: {
            //             ...form.rules.workflow_base_edit,
            //             typeSpecificSection: {
            //                 // ...form.rules.workflow_base_edit.typeSpecificSection,
            //                 sections: item
            //                 // sections: [...form.rules.workflow_base_edit.typeSpecificSection.sections, item[item.length - 1]]
            //             }
            //         }
            //     }
            // }))
        } catch (err) {
            throw err;
        }
    }

    const formApprovalSectionHandler = (item, index) => {
        try {
            setWorkflowData((prevstate) => {
                const updatedCondition = prevstate.approvalUserList.map((user, rowIndex) =>
                    rowIndex === index ? {
                        ...user,
                        approvalSections: item
                    } : user
                );
                return {
                    ...prevstate,
                    approvalUserList: updatedCondition
                };
            });
        } catch (err) {
            throw err;
        }
    }

    const formPrimaryFieldHandler = (e, index) => {
        try {
            setWorkflowData((prevstate) => {
                const updatedCondition = prevstate.approvalUserList.map((user, rowIndex) =>
                    rowIndex === index ? {
                        ...user,
                        primaryField: e?.target?.value
                    } : user
                );
                return {
                    ...prevstate,
                    approvalUserList: updatedCondition
                };
            });
        } catch (err) {
            throw err;
        }
    }

    // useEffect(() => {
    //     if (workflowList.createStatus) {
    //         // dispatch(getManageModulesStart());
    //         navigate("/workflow-rules")
    //     }
    // }, [workflowList.createStatus]);

    const addEditHandle = (type) => {
        if (type == 'base') {
            if (edit1 == true)
                setDisplayOption({ ...displayOption, create1: false })
            else
                setDisplayOption({ ...displayOption, create1: false, create2: true })
        }
        else {
            let type = typeof workflowData?.rules?.conditions;
            if (type === 'object') {
                let conditionList = workflowData?.rules?.conditions;
                if (conditionList.length > 0) {
                    for (let i = 0; i < conditionList.length; i++) {
                        if (conditionList[i].condition === "" || conditionList[i].field === "" || (conditionList[i].condition !== "is_empty" && conditionList[i].condition !== "isnt_empty" && conditionList[i].value === "")) {
                            toast.info('Please provide a valid criteria to proceed.', {
                            });
                            return;
                        } else {
                            if (edit2 == true)
                                setDisplayOption({ ...displayOption, create2: false })
                            else
                                setDisplayOption({ ...displayOption, create2: false, create3: true })
                        }
                    }
                }
            }
            else if (type === 'string') {
                if (edit2 == true)
                    setDisplayOption({ ...displayOption, create2: false })
                else
                    setDisplayOption({ ...displayOption, create2: false, create3: true })
            }
            // if (edit2 == true)
            //     setDisplayOption({ ...displayOption, create2: false })
            // else
            //     setDisplayOption({ ...displayOption, create2: false, create3: true })
        }
    }

    const handleRemoveUser = (index) => {
        if (workflowData.approvalUserList.length > 1) {
            setWorkflowData((prev) => ({
                ...prev,
                approvalUserList: prev.approvalUserList.filter((_, i) => i !== index),
            }));
            updateApprovalUserHandler()
        }
    }

    const updateApprovalUserHandler = () => {
        try {
            setWorkflowData((prevstate) => {
                const updatedCondition = prevstate.approvalUserList.map((user, rowIndex) =>
                ({
                    ...user,
                    position: rowIndex + 1,
                    status: 'Approval ' + (rowIndex + 1)
                })
                );
                return {
                    ...prevstate,
                    approvalUserList: updatedCondition
                };
            })
        } catch (err) {
            throw err;
        }
    }

    const options = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ]


    // React Select collapse dropdown


    let [userData, setUserData] = useState([]);
    let [roleData, setRoleData] = useState([]);
    useEffect(() => {
        if (allUsers?.allUserData?.length > 0) {
            let arr = []
            allUsers?.allUserData?.forEach(element => {
                arr.push({ value: element._id, label: element.firstName + ' ' + element.lastName })
            });
            setUserData(arr)
        }
    }, [allUsers])

    useEffect(() => {
        if (allRoles?.roleData?.length > 0) {
            let arr = []
            allRoles?.roleData?.forEach(element => {
                arr.push({ value: element._id, label: element.role_name })
            });
            setRoleData(arr)
        }

        if (roleData.length > 0 && userData.length > 0)
            if (!workflowData.rules.emailData.isSingleMail) {
                setDepartmentOptions([
                    {
                        label: "Roles",
                        options: roleData
                    },
                    {
                        label: "Users",
                        options: userData
                    }
                ]);
            }
    }, [allRoles])

    const [departmentOptions, setDepartmentOptions] = useState([]);

    // if(roleData.length>0&&userData.length>0)
    // if (!workflowData.rules.emailData.isSingleMail) {
    //     setDepartmentOptions([
    //         {
    //             label: "Roles",
    //             options: roleData
    //         },
    //         {
    //             label: "Users",
    //             options: userData
    //         }
    //     ]);
    // }

    const company1Options = [
        // { value: 0, label: "Marketing Team" },
        // { value: 1, label: "Human Resource" },
        // { value: 2, label: "Manager" }, //, isDisabled: true
        // { value: 3, label: "Team Lead" },
        // { value: 4, label: "Supervisor" },
        // { value: 5, label: "UI Designer" },
    ];
    const company2Options = [
        // { value: 0, label: "Marketing Team Manager" },
        // { value: 1, label: "Human Resource (HR Lead)" },
        // { value: 2, label: "Manager" },
        // { value: 3, label: "Technical Lead" },
        // { value: 4, label: "Team Lead" },
        // { value: 5, label: "UI/UX Designer" },
        // { value: 5, label: "Security advisor" },
    ];
    const company3Options = [
        // { value: 0, label: "Marketing Team Manager" },
        // { value: 1, label: "Human Resource (HR Lead)" },
        // { value: 2, label: "Manager" },
        // { value: 3, label: "Technical Lead" },
        // { value: 4, label: "Team Lead" },
        // { value: 5, label: "UI/UX Designer" },
        // { value: 5, label: "Security advisor" },
    ];
    const company4Options = [
        // { value: 0, label: "Marketing Team Manager" },
        // { value: 1, label: "Human Resource (HR Lead)" },
        // { value: 2, label: "Manager" },
        // { value: 3, label: "Technical Lead" },
        // { value: 4, label: "Team Lead" },
        // { value: 5, label: "UI/UX Designer" },
        // { value: 5, label: "Security advisor" },
    ];

    const mailHandler = (e) => {
        setWorkflowData((prev) => ({
            ...prev,
            rules: {
                ...prev.rules,
                emailData: {
                    ...prev.rules.emailData,
                    isSingleMail: e?.target?.checked
                }
            }
        }))
    }

    const handleToUserChange = (selected) => {
        setWorkflowData((prev) => ({
            ...prev,
            rules: {
                ...prev.rules,
                emailData: {
                    ...prev.rules.emailData,
                    to: selected
                }
            }
        }))
    }

    const handleCcUserChange = (selected) => {
        setWorkflowData((prev) => ({
            ...prev,
            rules: {
                ...prev.rules,
                emailData: {
                    ...prev.rules.emailData,
                    cc: selected
                }
            }
        }))
    }

    const handleBccUserChange = (selected) => {
        setWorkflowData((prev) => ({
            ...prev,
            rules: {
                ...prev.rules,
                emailData: {
                    ...prev.rules.emailData,
                    bcc: selected
                }
            }
        }))
    }



    useEffect(() => {
        setWorkflowData((prev) => ({
            ...prev,
            rules: {
                ...prev.rules,
                emailData: {
                    ...prev.rules.emailData,
                    to: []
                }
            }
        }))
        if (workflowData.rules.emailData.isSingleMail) {
            setDepartmentOptions([
                {
                    label: "Users",
                    options: userData
                }
            ]);
        } else {
            setDepartmentOptions([
                {
                    label: "Roles",
                    options: roleData
                },
                {
                    label: "Users",
                    options: userData
                }
            ]);
        }
    }, [workflowData.rules.emailData.isSingleMail])

    const HideGroupHeading = (props) => {
        return (
            <div
                className="collapse-group-heading"
                onClick={() => {
                    document
                        .querySelector(`#${props.id}`)
                        .parentElement.parentElement.classList.toggle("collapsed-group");
                }}
            >
                <components.GroupHeading {...props} />
            </div>
        );
    };

    const HideGroupMenuList = (props) => {
        let new_props = {
            ...props,
            children: Array.isArray(props.children)
                ? props.children.map((c, idx) =>
                    idx === 0
                        ? c
                        : { ...c, props: { ...c.props, className: "collapsed-group" } }
                )
                : props.children,
        };

        return <components.MenuList {...new_props} />;
    };

    // html template
    const generateEmailHTMLOld = () => {
        return `
      <html>
        <head>
        <style>
            body { font-family: Arial, sans-serif; }
            .email-container { width: 100%; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #ddd; background-color: #f9f9f9; }
            .email-header {color: #333; padding: 10px; text-align: center; }
            .email-body { padding: 20px; }
            .footer { text-align: center; color: #888; font-size: 12px; padding: 10px 0; }
            a { color: #007BFF; text-decoration: none; }
          </style>
        </head>
        <body>
          <div class="email-container">
            <div class="email-header">
              <h1>${emailData.subject}</h1>
            </div>
            <div class="email-body">
              <p>${emailData.content}</p>
            </div>
            </div>
        </body>
      </html>
    `;
    };

    const generateEmailHTML = () => {
        return `
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; }
            .email-container { width: 100%; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #ddd; background-color: #f9f9f9; }
            .email-header { color: #fff; padding: 10px; text-align: center; }
            .email-body { padding: 20px; }
            .email-content { line-height: 1.5; white-space: pre-wrap; word-wrap: break-word; overflow-y: auto; padding: 10px 0; }
            .footer { text-align: center; color: #888; font-size: 12px; padding: 10px 0; }
            a { color: #007BFF; text-decoration: none; }
            .signature { height: 36px; width: 90px; }
          </style>
        </head>
        <body>
          <div class="email-container">
            <div class="email-header">
                <img class="logo" src=${currentOrg?.companyData?.[0]?.profilePicture} alt="Logo" width="90" height="36" />
            </div>
            <div class="email-body">
                <p class="email-content">${emailData.content}</p>
                <p>Best regards,<br />${currentOrg?.companyData?.[0]?.organizationName}</p>
                ${emailData.signature ?
                `<div>
                        <img class="signature" src=${emailData.signature} alt="signature"/>
                    </div>`
                : `<div></div>`
            }
            </div>
          </div>
        </body>
      </html>
    `;
    };

    const previewModal = () => {
        // console.log('prview?', generateEmailHTML())
    }

    // UI
    return (
        <React.Fragment>
            <Loader isVisible={showLoader || workflowList?.isLoading} />
            {<Toast />}
            {/* <div className="main-panel"> */}
            <main className="py-md-4 content-section">
                <div className="container-fluid">
                    <h6 className="text-start">{workflowData?.ruleName}</h6>
                    <p className="text-start m-0">@ {module_name}</p>
                    <p className="text-start">{workflowData?.ruleDescription}</p>

                    <Row>
                        <Col lg={8}>
                            <div className="digy-workflow-card">
                                <form>
                                    {displayOption?.create1 && (
                                        <div className="form-group card mb-2">
                                            <p className="text-start">Execute this workflow rule based on</p>
                                            <select
                                                className="form-select mb-3"
                                                name="workflow_base"
                                                value={workflowData.rules.workflow_base}
                                                onChange={formHandler}
                                                required
                                                disabled={id && isEdit}
                                            >
                                                <option value="" disabled selected>Select</option>
                                                {moduleForm[0].rule_base_options.map((option, i) => (
                                                    <option value={option.value}
                                                        disabled={option.disabled ? true : null}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                            {subOptions.length > 0 && (
                                                <>
                                                    {workflowData.rules.workflow_base == 'datetime_field' &&
                                                        <p>Based on which Date/Time field this rule should execute</p>
                                                    }
                                                    <select
                                                        className="form-select mb-3"
                                                        id="sub-select"
                                                        name="workflow_base_type"
                                                        value={workflowData.rules.workflow_base_type}
                                                        onChange={formHandler}
                                                        required>
                                                        {subOptions.map((subOption) => (
                                                            <option value={subOption.value}
                                                                disabled={subOption.disabled ? true : null}>
                                                                {subOption.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </>
                                            )}
                                            {/* record action ui */}
                                            {workflowData.rules.workflow_base == 'record_action' &&
                                                <>
                                                    {workflowData.rules.workflow_base_type == 'create_edit' &&
                                                        <div className="form-group sub_options mb-3">
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" id="agreeToc"
                                                                    onChange={formHandler}
                                                                    name="isRepeatCreateEdit" checked={workflowData?.rules?.workflow_base_create_edit?.isRepeatCreateEdit} />
                                                                <label className="form-check-label">Repeat this workflow whenever a Meeting is edited</label>
                                                            </div>
                                                        </div>
                                                    }
                                                    {workflowData.rules.workflow_base_type == 'edit' &&
                                                        <div className="row form-group sub_options m-0 mb-3 pt-3">
                                                            <div className="col-12 mb-3">
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" id="agreeToc"
                                                                        onChange={formHandler}
                                                                        name="isRepeatEdit" checked={workflowData?.rules?.workflow_base_edit?.isRepeatEdit}
                                                                    />
                                                                    <label className="form-check-label">Repeat this workflow whenever a Meeting is edited</label>
                                                                </div>
                                                                {/* </div>
                                                    <div className="col-12 mb-3"> */}
                                                                <select
                                                                    className="form-select mb-3"
                                                                    name="type"
                                                                    value={workflowData.rules.workflow_base_edit.type}
                                                                    onChange={formHandler}
                                                                >
                                                                    <option value="any_field">Any field gets modified</option>
                                                                    <option value="specific_field">Specific field(s) gets modified</option>
                                                                    <option value="specific_section">Any field in specific section(s) gets modified</option>
                                                                </select>
                                                                {/* </div>
                                                    <div className="col-12"> */}
                                                                {/* sample:start */}
                                                                {workflowData.rules.workflow_base_edit.type == 'specific_field' &&
                                                                    <>
                                                                        {typeof workflowData?.rules?.workflow_base_edit?.typeSpecificField?.fieldConditions == 'object' ?
                                                                            <>
                                                                                {workflowData?.rules?.workflow_base_edit?.typeSpecificField?.fieldConditions?.map((dta, index) => (
                                                                                    <div className="row mt-2">
                                                                                        <label className="col-1">When</label>
                                                                                        <div className="col-2">
                                                                                            <select
                                                                                                className="form-select"
                                                                                                id="sub-select"
                                                                                                name="field"
                                                                                                // value={dta.id + '#' + dta.field + '#' + dta.type}
                                                                                                value={dta?.field}
                                                                                                onChange={(e) => editFormConditionHandler(e, index)}>
                                                                                                <option value="" disabled selected>Select</option>
                                                                                                {fieldList.map((data) => (
                                                                                                    <option value={data?.id + '#' + data?.extra_fields?.field_label + '#' + data?.input_type}>
                                                                                                        {data?.extra_fields?.field_label}
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                        <label className="col-2">is modified to</label>
                                                                                        <div className="col-2">
                                                                                            {dta?.type == 'select' || dta?.type == 'multi-select' ?
                                                                                                <select
                                                                                                    className="form-select"
                                                                                                    id="sub-select"
                                                                                                    name="value"
                                                                                                    value={dta.value}
                                                                                                    onChange={(e) => editFormConditionHandler(e, index)}
                                                                                                >
                                                                                                    <option value="" disabled selected>Select</option>
                                                                                                    {dta?.type == 'select' && fieldList.map((field) =>
                                                                                                        field.id == dta.id && (
                                                                                                            <>
                                                                                                                {field?.extra_fields?.options.map((item) => (
                                                                                                                    <option key={item} value={item}>
                                                                                                                        {item}
                                                                                                                    </option>
                                                                                                                ))}
                                                                                                            </>
                                                                                                        ))
                                                                                                    }
                                                                                                    {dta?.type == 'multi-select' && fieldList.map((field) =>
                                                                                                        field.id == dta.id && (
                                                                                                            <>
                                                                                                                {field?.extra_fields?.options.map((item) => (
                                                                                                                    <option key={item.name} value={item.name}>
                                                                                                                        {item.name}
                                                                                                                    </option>
                                                                                                                ))}
                                                                                                            </>
                                                                                                        ))
                                                                                                    }
                                                                                                </select>
                                                                                                :
                                                                                                <select
                                                                                                    className="form-select"
                                                                                                    id="sub-select"
                                                                                                    name="condition"
                                                                                                    value={dta.condition}
                                                                                                    onChange={(e) => editFormConditionHandler(e, index)}
                                                                                                >
                                                                                                    <option value="" disabled selected>any value</option>
                                                                                                    {editConditions.map((condition) => (
                                                                                                        <option value={condition.name}>
                                                                                                            {condition.value}
                                                                                                        </option>
                                                                                                    ))}
                                                                                                </select>
                                                                                            }
                                                                                        </div>
                                                                                        {dta?.condition !== ''
                                                                                            && dta?.condition !== 'is_empty'
                                                                                            && dta?.condition !== 'isnt_empty'
                                                                                            &&
                                                                                            <div className="col-2">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    name="value"
                                                                                                    className="form-control"
                                                                                                    value={dta.value}
                                                                                                    onChange={(e) => editFormConditionHandler(e, index)}
                                                                                                />
                                                                                            </div>
                                                                                        }
                                                                                        <button type="button" className="form-control btn btn-light col-3 me-2 w-10"
                                                                                            onClick={handleEditAddField}>+</button>
                                                                                        <button type="button" className="form-control btn btn-light col-3 w-10"
                                                                                            onClick={() => handleEditRemoveField(index)}>-</button>

                                                                                    </div>
                                                                                ))
                                                                                }
                                                                            </> : <></>
                                                                        }
                                                                    </>
                                                                }

                                                                {/* sample:end */}
                                                                {/* new ui:start */}
                                                                {workflowData.rules.workflow_base_edit.type == 'specific_field' &&
                                                                    <div className="row d-none">
                                                                        <label className="col-1">When</label>
                                                                        <div className="col-2">
                                                                            <select
                                                                                className="form-select"
                                                                                id="sub-select"
                                                                            >
                                                                                <option value="" disabled selected>Select</option>
                                                                                {fieldList.map((data) => (
                                                                                    <option value={data?.id + '#' + data?.extra_fields?.field_label + '#' + data?.input_type}>
                                                                                        {data?.extra_fields?.field_label}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <label className="col-2">is modified on</label>
                                                                        <div className="col-2">
                                                                            <select
                                                                                className="form-select"
                                                                                id="sub-select"
                                                                            >
                                                                                <option value="" disabled selected>Select</option>
                                                                                {conditions.map((condition) => (
                                                                                    <option key={condition.value} value={condition.value}>
                                                                                        {condition.name}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <input
                                                                                type="text"
                                                                                name="value"
                                                                                className="form-control"
                                                                            />
                                                                        </div>
                                                                        <div className="col-1">
                                                                            <button type="button" className="btn btn-light"
                                                                            >+</button>
                                                                        </div>
                                                                        <div className="col-1">
                                                                            <button type="button" className="btn btn-light"
                                                                            >-</button>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                {/* new ui:end */}
                                                                {/* {workflowData.rules.workflow_base_edit.type == 'specific_field' &&
                                                                    <Row className="mt-3 m-0">
                                                                        <label className="col-1">When</label>
                                                                        <select
                                                                            className="form-select mb-3 me-3 col-2 w-22"
                                                                            id="sub-select"
                                                                        >
                                                                            <option value="" disabled selected>Select</option>
                                                                            {fieldList.map((data) => (
                                                                                <option value={data?.id + '#' + data?.extra_fields?.field_label + '#' + data?.input_type}>
                                                                                    {data?.extra_fields?.field_label}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <label className="col-2">is modified on</label>
                                                                        <select
                                                                            className="form-control mb-3 me-3 col-2 w-22"
                                                                            id="sub-select"
                                                                        >
                                                                            <option value="" disabled selected>Select</option>
                                                                            {conditions.map((condition) => (
                                                                                <option key={condition.value} value={condition.value}>
                                                                                    {condition.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>

                                                                        <input
                                                                            type="text"
                                                                            name="value"
                                                                            className="form-control me-3 col-2 w-22"
                                                                        />

                                                                        <button type="button" className="form-control btn btn-light col-2 w-22"
                                                                        >+</button>
                                                                    </Row>
                                                                } */}
                                                                {workflowData.rules.workflow_base_edit.type == 'specific_section' &&
                                                                    <Row className="mt-3 m-0">
                                                                        <div className="col-6">
                                                                            <label>Layout</label>
                                                                            <select
                                                                                className="form-select mb-3 me-3 col-2"
                                                                                id="sub-select"
                                                                                name="layout"
                                                                                value={workflowData.rules.workflow_base_edit.typeSpecificSection.layout}
                                                                            >
                                                                                <option value="Standard" disabled selected>Standard</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <label>Sections</label>
                                                                            <select
                                                                                className="form-select mb-3 me-3 col-2"
                                                                                id="sub-select"
                                                                                name="sections"
                                                                                value={workflowData.rules.workflow_base_edit.typeSpecificSection.sections}
                                                                                onChange={formHandler}
                                                                            >
                                                                                <option>Select Section</option>
                                                                                {sectionsData.length > 0 && sectionsData.map((data) => (
                                                                                    <option value={data.value}>{data.label}</option>
                                                                                ))
                                                                                }
                                                                            </select>
                                                                            {/* <Select
                                                                                className="form-select mb-3 me-3 col-2"
                                                                                placeholder="Sections"
                                                                                closeMenuOnSelect={false}
                                                                                options={sectionsData}
                                                                                isMulti
                                                                                name="typeSpecificSection"
                                                                                // value={dta.approvalSections}
                                                                                // onChange={(e) => formApprovalSectionHandler(e, index)}
                                                                                value={workflowData.rules.workflow_base_edit.typeSpecificSection}
                                                                                // onChange={formHandler}
                                                                                onChange={(e) => formSectionHandler(e)}
                                                                            /> */}
                                                                        </div>
                                                                    </Row>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            }
                                            {workflowData.rules.workflow_base == 'datetime_field' &&
                                                <>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <p>Define execution date</p>
                                                        </div>
                                                        <div className="col-3">
                                                            <select
                                                                className="form-select mb-3"
                                                                id="sub-select"
                                                            >
                                                                <option>On</option>
                                                                <option>1 day after</option>
                                                                <option>2 days after</option>
                                                                <option>1 week after</option>
                                                                <option>1 month after</option>
                                                                <option>1 year after</option>
                                                                <option>Custom</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-3">
                                                            <p>the date in Created Time field</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <p>Execution time</p>
                                                        </div>
                                                        <div className="col-6">
                                                            <div className="col-auto">
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="radio" name="businessHours" id="busiHourRadio1" value="24x7"
                                                                    // onChange={formHandler} checked={businessHoursData?.businessHours == "24x7"}
                                                                    />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="busiHourRadio1">
                                                                        Same as the time in Created Time field
                                                                    </label>
                                                                </div>
                                                                <div className="form-check form-group">
                                                                    <input className="form-check-input" type="radio" name="businessHours" id="busiHourRadio2" value="24x5"
                                                                    // onChange={formHandler} checked={businessHoursData?.businessHours == "24x5"} 
                                                                    />
                                                                    <select
                                                                        className="form-select mb-3 ms-2"
                                                                        id="sub-select"
                                                                        style={{ width: '45%' }}
                                                                    >
                                                                        <option>5 minutes after</option>
                                                                        <option>10 minutes after</option>
                                                                        <option>15 minutes after</option>
                                                                        <option>30 minutes after</option>
                                                                        <option>1 hour after</option>
                                                                        <option>2 hours after</option>
                                                                        <option>Custom</option>
                                                                    </select>
                                                                    <p className="form-check-label cursor-pointer" htmlFor="busiHourRadio2">
                                                                        the time in Created Time field
                                                                    </p>
                                                                </div>
                                                                <div className="form-check form-group">
                                                                    <input className="form-check-input" type="radio" name="businessHours" id="busiHourRadio2" value="24x5"
                                                                    // onChange={formHandler} checked={businessHoursData?.businessHours == "24x5"} 
                                                                    />
                                                                    <select
                                                                        className="form-select mb-3 ms-2"
                                                                        id="sub-select"
                                                                        style={{ width: '45%' }}
                                                                    >
                                                                        <option>08:00 AM</option>
                                                                        <option>08:30 AM</option>
                                                                    </select>
                                                                    <p className="form-check-label cursor-pointer" htmlFor="busiHourRadio2">
                                                                        Asia/Kolkata
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <p>Recur</p>
                                                        </div>
                                                        <div className="col-3">
                                                            <select
                                                                className="form-select mb-3"
                                                                id="sub-select"
                                                            >
                                                                <option>Once</option>
                                                                <option>Every Month</option>
                                                                <option>Every Year</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {workflowData.rules.workflow_base == 'record_score' &&
                                                <>
                                                    <div className="row">
                                                        <div className="col-3">This rule should be applied for</div>
                                                        <div className="col-3">
                                                            <select
                                                                className="form-select mb-3"
                                                                id="sub-select"
                                                            >
                                                                <option>All Scoring Rules</option>
                                                                <option>Selective Scoring Rules</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-3">
                                                            <select
                                                                className="form-select mb-3"
                                                                id="sub-select"
                                                            >
                                                                <option>Increased</option>
                                                                <option>Decreased</option>
                                                                <option>Updated</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            <button type="button" className="btn btn-primary float-end w-25" onClick={() => addEditHandle('base')}
                                                disabled={!isBaseCardComplete}>Next</button>
                                        </div>)
                                    }
                                    {
                                        !displayOption?.create1 && (
                                            <div className="form-group card text-start mb-2">
                                                <p>This rule will be executed when a <b>{module_name}</b> is <b>{workflowData?.rules?.workflow_base_type}</b>
                                                    <FaPencil className="float-end" onClick={() => { setEdit1(true); setDisplayOption({ ...displayOption, create1: true }) }} />
                                                </p>
                                            </div>)
                                    }
                                    {displayOption?.create2 && (
                                        <>
                                            {workflowData.rules.workflow_base == 'record_notes' ?
                                                <>
                                                    <div className="form-group card mb-2">
                                                        <p className="text-start">Which contacts would you like to apply the rule to?</p>

                                                        <div className="row">
                                                            <div className="col-6">
                                                                <p>Would you like to set conditions for lead fields?</p>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="col-auto">
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="radio" name="businessHours" id="busiHourRadio1" value="24x7"
                                                                        // onChange={formHandler} checked={businessHoursData?.businessHours == "24x7"}
                                                                        />
                                                                        <label className="form-check-label cursor-pointer" htmlFor="busiHourRadio1">
                                                                            Yes
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="radio" name="businessHours" id="busiHourRadio1" value="24x7"
                                                                        // onChange={formHandler} checked={businessHoursData?.businessHours == "24x7"}
                                                                        />
                                                                        <label className="form-check-label cursor-pointer" htmlFor="busiHourRadio1">
                                                                            No
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-6">
                                                                <p>Which notes would you like to apply this rule to?</p>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="col-auto">
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="radio" name="businessHours" id="busiHourRadio1" value="24x7"
                                                                        // onChange={formHandler} checked={businessHoursData?.businessHours == "24x7"}
                                                                        />
                                                                        <label className="form-check-label cursor-pointer" htmlFor="busiHourRadio1">
                                                                            All Notes
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="radio" name="businessHours" id="busiHourRadio1" value="24x7"
                                                                        // onChange={formHandler} checked={businessHoursData?.businessHours == "24x7"}
                                                                        />
                                                                        <label className="form-check-label cursor-pointer" htmlFor="busiHourRadio1">
                                                                            Notes matching certain condition
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="form-check form-group">
                                                                    <p className="form-check-label cursor-pointer" htmlFor="busiHourRadio2">
                                                                        Notes matching
                                                                    </p>
                                                                    <select
                                                                        className="form-select mb-3"
                                                                        id="sub-select"
                                                                    >
                                                                        <option>all</option>
                                                                        <option>any</option>
                                                                    </select>
                                                                    <p className="form-check-label cursor-pointer" htmlFor="busiHourRadio2">
                                                                        of these conditions
                                                                    </p>
                                                                </div>
                                                                <>
                                                                    {typeof workflowData?.rules?.conditions == 'object' ?
                                                                        <>
                                                                            {isShowContact && workflowData?.rules?.conditions?.map((dta, index) => (
                                                                                <Row className="mt-3 m-0">
                                                                                    <select
                                                                                        className="form-select mb-3 me-3 col-3 w-22"
                                                                                        id="sub-select"
                                                                                        name="field"
                                                                                        // value={dta.id + '#' + dta.field + '#' + dta.type}
                                                                                        value={dta?.field}
                                                                                        onChange={(e) => formConditionHandler(e, index)}>
                                                                                        <option value="" disabled selected>Select</option>
                                                                                        {fieldList.map((data) => (
                                                                                            <option value={data?.id + '#' + data?.extra_fields?.field_label + '#' + data?.input_type}>
                                                                                                {data?.extra_fields?.field_label}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>

                                                                                    <select
                                                                                        className="form-select mb-3 me-3 col-3 w-22"
                                                                                        id="sub-select"
                                                                                        name="condition"
                                                                                        value={dta.condition}
                                                                                        onChange={(e) => formConditionHandler(e, index)}
                                                                                    >
                                                                                        <option value="" disabled selected>Select</option>
                                                                                        {conditions.map((condition) => (
                                                                                            <option value={condition.name}>
                                                                                                {condition.value}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                    {dta?.condition !== 'is_empty' && dta?.condition !== 'isnt_empty' && <>

                                                                                        {dta?.type == 'select' || dta?.type == 'multi-select' ?
                                                                                            <select
                                                                                                className="form-select mb-3 me-3 col-3 w-22"
                                                                                                id="sub-select"
                                                                                                name="value"
                                                                                                value={dta.value}
                                                                                                onChange={(e) => formConditionHandler(e, index)}
                                                                                            >
                                                                                                <option value="" disabled selected>Select</option>

                                                                                                {dta?.type == 'select' && fieldList.map((field) =>
                                                                                                    field.id == dta.id && (
                                                                                                        <>
                                                                                                            {field?.extra_fields?.options.map((item) => (
                                                                                                                <option key={item} value={item}>
                                                                                                                    {item}
                                                                                                                </option>
                                                                                                            ))}
                                                                                                        </>
                                                                                                    ))
                                                                                                }
                                                                                                {dta?.type == 'multi-select' && fieldList.map((field) =>
                                                                                                    field.id == dta.id && (
                                                                                                        <>
                                                                                                            {field?.extra_fields?.options.map((item) => (
                                                                                                                <option key={item.name} value={item.name}>
                                                                                                                    {item.name}
                                                                                                                </option>
                                                                                                            ))}
                                                                                                        </>
                                                                                                    ))
                                                                                                }
                                                                                            </select>
                                                                                            :
                                                                                            <input
                                                                                                type="text"
                                                                                                name="value"
                                                                                                className="form-control me-3 col-3 w-22"
                                                                                                value={dta.value}
                                                                                                onChange={(e) => formConditionHandler(e, index)}
                                                                                            />
                                                                                        }
                                                                                    </>
                                                                                    }

                                                                                    <button type="button" className="form-control btn btn-light col-3 me-2 w-10"
                                                                                        onClick={handleAddField}>+</button>
                                                                                    <button type="button" className="form-control btn btn-light col-3 w-10"
                                                                                        onClick={() => handleRemoveField(index)}>-</button>

                                                                                </Row>
                                                                            ))
                                                                            }
                                                                        </> : <></>
                                                                    }
                                                                </>
                                                            </div>
                                                        </div>
                                                        <button type="button" className="btn btn-primary float-end w-25 mt-2" onClick={() => addEditHandle('condition')}>Next</button>
                                                    </div>
                                                </>
                                                :
                                                <div className="form-group card mb-2">
                                                    <p className="text-start">Which contacts would you like to apply the rule to?</p>

                                                    <div className="form-control d-flex">
                                                        <div>
                                                            <input type="radio" value="matching_contact" name="contactType" onChange={formHandler} checked={workflowData?.rules?.contactType === "matching_contact"} /> Contacts matching certain conditions
                                                        </div>
                                                        <div>
                                                            <input className="ms-5" type="radio" value="all_contact" name="contactType" onChange={formHandler} checked={workflowData?.rules?.contactType === "all_contact"} /> All Records
                                                        </div>
                                                    </div>

                                                    {typeof workflowData?.rules?.conditions == 'object' &&
                                                        <>
                                                            {isShowContact && workflowData?.rules?.conditions?.map((dta, index) => (
                                                                <Row className="mt-3 m-0">
                                                                    <select
                                                                        className="form-select mb-3 me-3 col-3 w-22"
                                                                        id="sub-select"
                                                                        name="field"
                                                                        // value={dta.id + '#' + dta.field + '#' + dta.type}
                                                                        value={dta?.field}
                                                                        onChange={(e) => formConditionHandler(e, index)}>
                                                                        <option value="" disabled selected>Select</option>
                                                                        {fieldList.map((data) => (
                                                                            <option value={data?.id + '#' + data?.extra_fields?.field_label + '#' + data?.input_type}>
                                                                                {data?.extra_fields?.field_label}
                                                                            </option>
                                                                        ))}
                                                                    </select>

                                                                    <select
                                                                        className="form-select mb-3 me-3 col-3 w-22"
                                                                        id="sub-select"
                                                                        name="condition"
                                                                        value={dta.condition}
                                                                        onChange={(e) => formConditionHandler(e, index)}
                                                                    >
                                                                        <option value="" disabled selected>Select</option>
                                                                        {conditions.map((condition) => (
                                                                            <option value={condition.name}>
                                                                                {condition.value}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    {dta?.condition !== 'is_empty' && dta?.condition !== 'isnt_empty' && <>

                                                                        {dta?.type == 'select' || dta?.type == 'multi-select' ?
                                                                            <select
                                                                                className="form-select mb-3 me-3 col-3 w-22"
                                                                                id="sub-select"
                                                                                name="value"
                                                                                value={dta.value}
                                                                                onChange={(e) => formConditionHandler(e, index)}
                                                                            >
                                                                                <option value="" disabled selected>Select</option>

                                                                                {dta?.type == 'select' && fieldList.map((field) =>
                                                                                    field.id == dta.id && (
                                                                                        <>
                                                                                            {field?.extra_fields?.options.map((item) => (
                                                                                                <option key={item} value={item}>
                                                                                                    {item}
                                                                                                </option>
                                                                                            ))}
                                                                                        </>
                                                                                    ))
                                                                                }
                                                                                {dta?.type == 'multi-select' && fieldList.map((field) =>
                                                                                    field.id == dta.id && (
                                                                                        <>
                                                                                            {field?.extra_fields?.options.map((item) => (
                                                                                                <option key={item.name} value={item.name}>
                                                                                                    {item.name}
                                                                                                </option>
                                                                                            ))}
                                                                                        </>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            :
                                                                            <input
                                                                                type="text"
                                                                                name="value"
                                                                                className="form-control me-3 col-3 w-22"
                                                                                value={dta.value}
                                                                                onChange={(e) => formConditionHandler(e, index)}
                                                                            />
                                                                        }
                                                                    </>
                                                                    }

                                                                    <button type="button" className="form-control btn btn-light col-3 me-2 w-10"
                                                                        onClick={handleAddField}>+</button>
                                                                    <button type="button" className="form-control btn btn-light col-3 w-10"
                                                                        onClick={() => handleRemoveField(index)}>-</button>

                                                                </Row>
                                                            ))
                                                            }
                                                        </>
                                                    }

                                                    <button type="button" className="btn btn-primary float-end w-25 mt-2" onClick={() => addEditHandle('condition')}>Next</button>
                                                </div>
                                            }
                                        </>
                                    )}
                                    {
                                        displayOption?.create2 != null && !displayOption?.create2 && (
                                            <div className="form-group card wf-card mb-2">
                                                {typeof workflowData?.rules?.conditions == 'object' ?
                                                    <>
                                                        {workflowData?.rules?.conditions.map((list, index) => (
                                                            <>
                                                                <p className="text-start"><span>{index + 1}.</span>{list.field.split('#')[1]} <b>{list.condition}</b> {list.value}
                                                                    {index == 0 &&
                                                                        <FaPencil className="float-end" onClick={() => { setEdit2(true); setDisplayOption({ ...displayOption, create2: true }) }} />
                                                                    }
                                                                </p>
                                                            </>
                                                        ))}
                                                    </> : <>
                                                        <p className="text-start">All records
                                                            <FaPencil className="float-end" onClick={() => { setEdit2(true); setDisplayOption({ ...displayOption, create2: true }) }} />
                                                        </p>
                                                    </>
                                                }
                                            </div>)
                                    }
                                    {displayOption?.create3 && (
                                        <>
                                            <div className="form-group card mb-2">
                                                <Dropdown className='me-3' autoClose={`outside`} onSelect={(value) => setActionType(value)}>
                                                    <Dropdown.Toggle variant='light' id="time-filter-dropdown" className='form-select- mb-3 me-3 col-3 w-22 flat-btn bg-white with-arrow text-dark text-start'>
                                                        <span className='pe-3'>Instant Actions</span>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='p-0 fs-14'>
                                                        <Dropdown.Item eventKey="Approval" onClick={() => { setShowTable(false); openAction('approval_user') }}
                                                        // data-bs-toggle="modal" data-bs-target="#actionForm"
                                                        >Approval</Dropdown.Item>
                                                        {/* <Dropdown.Item eventKey="Field Update" data-bs-toggle="modal" data-bs-target="#actionForm">Field Update</Dropdown.Item>
                                                        <Dropdown.Item eventKey="Assign Owner" data-bs-toggle="modal" data-bs-target="#actionForm">Assign Owner</Dropdown.Item>
                                                        <Dropdown.ItemText className='p-0'>
                                                            <Dropdown drop={`end`}>
                                                                <Dropdown.Toggle as={CustomToggle} id="specific-date-dropdown">
                                                                    Tags
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className='p-0 border-0- fs-14'>
                                                                    <Dropdown.Item eventKey="Add Tags" data-bs-toggle="modal" data-bs-target="#actionForm">Add Tag(s)</Dropdown.Item>
                                                                    <Dropdown.Item eventKey="Remove Tags" data-bs-toggle="modal" data-bs-target="#actionForm">Remove Tag(s)</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </Dropdown.ItemText> */}
                                                        <Dropdown.Item eventKey="Email Notification" onClick={() => openAction('email')}
                                                        // data-bs-toggle="modal" data-bs-target="#actionForm"
                                                        >Email Notification</Dropdown.Item>
                                                        {/* <Dropdown.ItemText className='p-0'>
                                                            <Dropdown drop={`end`}>
                                                                <Dropdown.Toggle as={CustomToggle} id="date-range-dropdown">
                                                                    Activities
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className='p-0 border-0- fs-14'>
                                                                    <Dropdown.Item eventKey="Add Task" data-bs-toggle="modal" data-bs-target="#actionForm">Add Task</Dropdown.Item>
                                                                    <Dropdown.Item eventKey="Add Meeting" data-bs-toggle="modal" data-bs-target="#actionForm">Add Meeting</Dropdown.Item>
                                                                    <Dropdown.Item eventKey="Schedule Call" data-bs-toggle="modal" data-bs-target="#actionForm">Schedule a Call</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </Dropdown.ItemText>
                                                        <Dropdown.Item eventKey="Create Record" data-bs-toggle="modal" data-bs-target="#actionForm">Create Record</Dropdown.Item>
                                                        <Dropdown.Item eventKey="Convert" data-bs-toggle="modal" data-bs-target="#actionForm">Convert</Dropdown.Item>
                                                        <Dropdown.Item eventKey="Webhook" data-bs-toggle="modal" data-bs-target="#actionForm">Webhook</Dropdown.Item>
                                                        <Dropdown.Item eventKey="Function" data-bs-toggle="modal" data-bs-target="#actionForm">Function</Dropdown.Item> */}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                {/* <div className={`tbl-container rounded-table ${(workflowData.approvalUserList.length === 0) ||
                                                    (workflowData.approvalUserList.length === 1 && workflowData.approvalUserList[0].approvalSections === '' &&
                                                        workflowData.approvalUserList[0].primaryField && workflowData.approvalUserList[0].userId
                                                    ) &&
                                                    'd-none'}`}>
                                                    <div className='table-responsive'>
                                                        <table className="table mb-0">
                                                            <thead>
                                                                <th>Approval User</th>
                                                                <th>Approval Sections</th>
                                                                <th>Primary Field</th>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    workflowData?.approvalUserList?.length > 0 && workflowData.approvalUserList.map((data) => (
                                                                        <tr>
                                                                            <td>{data?.userId}</td>
                                                                            <td>{data?.approvalSections}</td>
                                                                            <td>{data?.primaryField}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div> */}
                                            </div>
                                            {showTable && workflowData?.approvalUserList.length > 0 &&
                                                (workflowData?.approvalUserList[0]?.approvalSections?.length > 0 && workflowData?.approvalUserList[0]?.primaryField !== '' && workflowData?.approvalUserList[0]?.userId !== '')
                                                &&
                                                <div className="">
                                                    <div className="form-group card mb-2">
                                                        <h6 className="fs-5">Instant Action - <span className="fw-semibold">User Approval</span></h6>
                                                        {/* {workflowData?.approvalUserList?.map((dta, index) => ( */}
                                                        <>
                                                            <div className="tbl-container rounded-table d-block">
                                                                <div className="table-responsive">
                                                                    <table className="table table-hover hover-icon-table shift-hour-table mb-0">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Approval User</th>
                                                                                <th>Approval Section</th>
                                                                                <th>Primary Field</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {workflowData?.approvalUserList?.map((dta, index) =>
                                                                                dta?.approvalSections?.length > 0 &&
                                                                                dta?.primaryField !== '' &&
                                                                                dta?.userId !== '' && (
                                                                                    <tr>
                                                                                        <td>{getAllUsers?.allUserData?.filter((data) => data._id === dta?.userId)?.[0]?.firstName + ' ' + getAllUsers?.allUserData?.filter((data) => data._id === dta?.userId)?.[0]?.lastName}</td>
                                                                                        <td>{dta?.approvalSections?.length > 0 && dta?.approvalSections?.map(item => item.value)?.join(', ')}</td>
                                                                                        <td>{dta?.primaryField}</td>
                                                                                    </tr>
                                                                                ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>

                                                        </>
                                                        {/* ))} */}
                                                    </div >
                                                </div>
                                            }
                                        </>)
                                    }

                                    <Col lg={6} className="text-start ps-0">
                                        <button className="btn btn-light rounded-pill py-1 px-3 flat-btn mt-3 me-2" type="button"
                                            onClick={() => navigate(Utils.getNavigationUrl('/workflow-rules'))}>Cancel</button>
                                        {!id && !isEdit ?
                                            (<button className="btn btn-primary rounded-pill btn-blue mt-3" type="button"
                                                onClick={handleSubmit}
                                                disabled={!isBaseCardComplete}>Submit</button>)
                                            :
                                            (< button className="btn btn-primary rounded-pill btn-blue mt-3" type="button"
                                                onClick={handleUpdate} disabled={!isBaseCardComplete}>Update</button>)
                                        }
                                    </Col>
                                </form>
                            </div>
                        </Col>
                    </Row>
                </div>
            </main >
            {/* </div > */}

            {/* Workflow Action Modal */}

            <Modal
                show={showApprovalUserModal}
                onHide={() => setShowApprovalUserModal(false)}
                backdrop="static"
                keyboard={false}
                className="modal-lg"
            >
                <Modal.Header>
                    {/* <Modal.Title>Create New Rule</Modal.Title> */}
                    {actionType == 'Function' && functionType !== '' &&
                        < h5 className="modal-title fs-5" id="actionFormLabel"><span className="cursor-pointer me-4" onClick={() => { setFunctionType(''); setGalleryConfigType('') }}>X</span> {functionType}</h5>
                    }
                    {actionType == 'Function' && functionType === '' &&
                        < h5 className="modal-title fs-5" id="actionFormLabel"><span className="cursor-pointer me-4" data-bs-dismiss="modal" onClick={() => { setFunctionType(''); setGalleryConfigType('') }}>X</span>Configure Function - <span className="fw-semibold">{module_name}</span></h5>
                    }
                    {actionType !== 'Function' &&
                        <h5 className="modal-title fs-5" id="actionFormLabel">{actionType} - <span className="fw-semibold">{module_name}</span></h5>
                    }
                </Modal.Header>
                <Modal.Body style={{ minHeight: '400px' }}>
                    {actionType === 'Approval' &&
                        <div className="form-group card mb-2">
                            {workflowData?.approvalUserList?.length > 0 && workflowData?.approvalUserList?.map((dta, index) => (
                                <>
                                    <div className="row ps-3">
                                        <select
                                            className="form-select mb-3 me-2 col-4 w-25"
                                            id="sub-select"
                                            name="userId"
                                            value={dta.userId}
                                            onChange={(e) => formApprovalUserHandler(e, index)}
                                        >
                                            <option value="" disabled selected>Approval User</option>
                                            {getAllUsers?.allUserData?.length > 0 && getAllUsers?.allUserData?.map((user) => (
                                                <option value={user._id}>
                                                    {user.firstName + user.lastName}
                                                </option>
                                            ))}
                                        </select>

                                        <Select
                                            className="mb-3 me-2 col-4 w-25"
                                            placeholder="Approval Sections"
                                            closeMenuOnSelect={false}
                                            options={sectionsData}
                                            isMulti
                                            name="approvalSections"
                                            value={dta.approvalSections}
                                            // onChange={(e) => formApprovalUserModuleHandler(e, index)}
                                            onChange={(e) => formApprovalSectionHandler(e, index)}
                                        />

                                        <select
                                            className="form-select mb-3 me-3 col-3 w-22"
                                            id="sub-select"
                                            placeholder="test"
                                            name="primaryField"
                                            value={dta.primaryField}
                                            onChange={(e) => formPrimaryFieldHandler(e, index)}
                                        >
                                            <option value="" disabled selected>Primary Field</option>
                                            {fieldList.map((data) => data?.extra_fields?.required == true ? (
                                                <option value={data?.extra_fields?.field_label}>
                                                    {data?.extra_fields?.field_label}
                                                </option>
                                            ) :
                                                (
                                                    <option value={data?.extra_fields?.field_label}>
                                                        {data?.extra_fields?.field_label}
                                                    </option>
                                                ))}
                                        </select>

                                        <button type="button" className="form-control btn btn-light col-2 w-10 mb-3 me-2"
                                            onClick={() => handleAddUser(index)}>+</button>
                                        <button type="button" className="form-control btn btn-light col-2 w-10 mb-3"
                                            onClick={() => handleRemoveUser(index)}>-</button>
                                    </div>
                                    <div className="row ps-3">
                                        {errors[index] && (
                                            <span style={{ color: 'red' }}>{errors[index]}</span>
                                        )}
                                    </div>
                                </>
                            ))}
                        </div>
                    }
                    {actionType === 'Email Notification' &&
                        <div className="form-group card mb-2">
                            <div className="row">
                                <label className="col-3">Name</label>
                                <div className="col-6">
                                    <input type="text" className="form-control" />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <label className="col-3">To</label>
                                <div className="col-6">
                                    <Select
                                        className="react-select multi-select react-select-container"
                                        options={departmentOptions}
                                        isMulti
                                        name="departmentOptions"
                                        classNamePrefix="select"
                                        blurInputOnSelect={false}
                                        closeMenuOnSelect={false}
                                        defaultMenuIsOpen={false}
                                        components={{
                                            GroupHeading: HideGroupHeading,
                                            MenuList: HideGroupMenuList,
                                        }}
                                        placeholder="Add Users"
                                        required
                                        value={workflowData.rules.emailData.to}
                                        onChange={handleToUserChange}
                                    />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <label className="col-3"></label>
                                <div className="col-9">
                                    <div className="form-control d-flex p-0"
                                        style={{ border: 'none' }}>
                                        {/* <div className="form-check"> */}
                                        <input className="form-check-input" type="checkbox" id="agreeToc" required="" value=""
                                            onChange={mailHandler}
                                            name="isSingleMail"
                                            checked={workflowData?.rules?.emailData?.isSingleMail} />
                                        <label className="form-check-label ms-2">Send this notification as a Single Mass Email with all recipients displayed</label>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                            {workflowData?.rules?.emailData?.isSingleMail &&
                                <>
                                    <div className="row mt-2">
                                        <label className="col-3">CC</label>
                                        <div className="col-6">
                                            <Select
                                                className="react-select multi-select react-select-container"
                                                options={departmentOptions}
                                                isMulti
                                                name="departmentOptions"
                                                classNamePrefix="select"
                                                blurInputOnSelect={false}
                                                closeMenuOnSelect={false}
                                                defaultMenuIsOpen={false}
                                                components={{
                                                    GroupHeading: HideGroupHeading,
                                                    MenuList: HideGroupMenuList,
                                                }}
                                                placeholder="Add Users"
                                                required
                                                value={workflowData.rules.emailData.cc}
                                                onChange={handleCcUserChange}
                                            />
                                        </div>
                                    </div>
                                    {!showBcc &&
                                        <div className="row mt-2">
                                            <label className="col-3"></label>
                                            <div className="col-6">
                                                <a style={{ color: 'rgba(13,110,253)', cursor: 'pointer' }} onClick={() => isShowBcc(true)}>BCC</a>
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                            {showBcc &&
                                <div className="row mt-2">
                                    <label className="col-3">BCC</label>
                                    <div className="col-6">
                                        <Select
                                            className="react-select multi-select react-select-container"
                                            options={departmentOptions}
                                            isMulti
                                            name="departmentOptions"
                                            classNamePrefix="select"
                                            blurInputOnSelect={false}
                                            closeMenuOnSelect={false}
                                            defaultMenuIsOpen={false}
                                            components={{
                                                GroupHeading: HideGroupHeading,
                                                MenuList: HideGroupMenuList,
                                            }}
                                            placeholder="Add Users"
                                            required
                                            value={workflowData.rules.emailData.bcc}
                                            onChange={handleBccUserChange}
                                        />
                                    </div>
                                </div>
                            }

                            <div className="row mt-2">
                                <label className="col-3">Email Template</label>
                                <div className="col-6">
                                    <button type="button" className="btn btn-outline-primary rounded-pill btn-blue"
                                        // data-bs-toggle="modal" data-bs-target="#emailTemplateForm"
                                        onClick={() => setShowTemplateModal(true)}
                                    // onClick={() => { setActionType(''); setShowAddTask(false) }}
                                    >Select Template</button>
                                </div>
                            </div>
                            <hr />
                            <div className="row mt-2">
                                <div className="col-12">
                                    <div className="form-control d-flex p-0"
                                        style={{ border: 'none' }}>
                                        {/* <div className="form-check"> */}
                                        <input className="form-check-input" type="checkbox" id="agreeToc" required="" value="" />
                                        <label className="form-check-label ms-2"> Send this email notification at Best Time to Email.</label>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline-primary rounded-pill btn-blue" data-bs-dismiss="modal" onClick={() => { setShowTable(true); setActionType(''); setShowAddTask(false); setShowApprovalUserModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-primary rounded-pill btn-blue" data-bs-dismiss="modal" onClick={handleSave}>Save</button>
                </Modal.Footer>
            </Modal>

            {/* Workflow Action Modal // */}
            {/* New Function Modal */}
            <div className="modal fade" id="newFunctionForm" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="newFunctionLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable com-details-form">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title fs-5" id="newFunctionLabel">New Function</h5>
                        </div>
                        <div className="modal-body pb-0">
                            <form>
                                <div className="form-group mb-3">
                                    <label htmlFor="comName" className="col-auto col-form-label">Function Name</label>
                                    <div className="col-auto input-control">
                                        <input type="text" className="form-control" id="comName" name="Company_Name" required
                                        // onChange={formHandler} value={companyData?.Company_Name} 
                                        />
                                    </div>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="comNameAlias" className="col-auto col-form-label">Display Name</label>
                                    <div className="col-auto input-control">
                                        <input type="text" className="form-control" id="comNameAlias" name="Alias" required
                                        // onChange={formHandler} value={companyData?.Alias} 
                                        />
                                    </div>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="empCount" className="col-auto col-form-label">Description</label>
                                    <div className="col-auto input-control">
                                        <input type="number" className="form-control" id="empCount" name="Employee_Count"
                                        // onChange={formHandler} value={companyData?.Employee_Count} 
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-primary rounded-pill btn-blue"
                            // data-bs-dismiss="modal"
                            // data-bs-toggle="modal" data-bs-target="#actionForm"
                            // onClick={() => { setShowApprovalUserModal(true) }}
                            >Cancel</button>
                            <button type="button" className="btn btn-primary rounded-pill btn-blue"
                                //  onClick={() => handleSubmit()} 
                                data-bs-dismiss="modal">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            {/* // New Function Modal // */}
            {/* New Function Modal */}
            {
                showTemplateModal &&
                <div className="modal fade show d-block" id="emailTemplateForm" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="emailTemplateFormLabel" aria-hidden="false">
                    <div className="modal-dialog modal-dialog-scrollable com-details-form modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fs-5" id="emailTemplateFormLabel">Email Template</h5>
                            </div>
                            <div className="modal-body pb-0">
                                <form>
                                    <div className="row align-items-center mb-3">
                                        <label htmlFor="moduleSelect" className="col-md-auto col-xl-2 text-md-end col-form-label">
                                            Module Select
                                        </label>
                                        <div className="col-md-auto col-xl-3">
                                            <select className="form-select" id="moduleSelect"
                                                name="moduleId"
                                                value={templateData.moduleId + '#' + templateData.moduleName}
                                                onChange={(e) => { handleTemplateData(e) }}>
                                                <option>Select Module</option>
                                                {
                                                    moduleList?.length > 0 && moduleList?.map((data) => (
                                                        <option value={data?._id + '#' + data?.name}>{data?.name}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>

                                        <label htmlFor="moduleSelect" className="col-md-auto col-xl-2 text-md-end col-form-label">
                                            Module Field
                                        </label>
                                        <div className="col-md-auto col-xl-3">
                                            <select className="form-select" id="moduleSelect"
                                                name="moduleFieldId"
                                                value={templateData.moduleFieldId + '#' + templateData.moduleFieldName}
                                                onChange={(e) => { handleTemplateData(e) }}
                                            >
                                                <option>Select Field</option>
                                                {
                                                    fieldList?.length > 0 && fieldList?.map((data) => (
                                                        <option value={data?.id + '#' + data?.extra_fields?.field_label}>{data?.extra_fields?.field_label}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row align-items-center mb-3">
                                        <label htmlFor="templateName" className="col-md-auto col-xl-2 text-md-end col-form-label">
                                            Template Name
                                        </label>
                                        <div className="col-md-auto col-xl-3">
                                            <input type="text" className="form-control" id="templateName" placeholder='Template name'
                                                name="templateName"
                                                value={emailData.templateName}
                                                onChange={(e) => { handleEmailData(e) }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row align-items-center mb-3">
                                        <label htmlFor="subject" className="col-md-auto col-xl-2 text-md-end col-form-label">
                                            Subject
                                        </label>
                                        <div className="col-md-auto col-xl-6">
                                            <input type="text" className="form-control" id="subject" placeholder='Email subject'
                                                name="subject"
                                                value={emailData.subject}
                                                onChange={(e) => { handleEmailData(e) }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row align-items-start mb-3">
                                        <label htmlFor="templateContent" className="col-md-auto col-xl-2 text-md-end col-form-label">
                                            Content
                                        </label>
                                        <div className="col-md-auto col-xl-6">
                                            <textarea className="form-control wf-content" id="templateContent" rows="10" placeholder='Email content'
                                                name="content"
                                                value={emailData.content}
                                                onChange={(e) => { handleEmailData(e) }}
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="row align-items-start mb-3">
                                        <label htmlFor="templateSignature" className="col-md-auto col-xl-2 text-md-end col-form-label">
                                            Signature
                                        </label>
                                        <div className="col-md-auto col-xl-3">
                                            <input type="file" className="form-control" id="templateSignature" aria-describedby="emailSignatureFileAddon" aria-label="Upload"
                                                onChange={onSelectFile} />
                                        </div>
                                        <p>preview:</p>
                                        <div dangerouslySetInnerHTML={{ __html: generateEmailHTML() }}></div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className={`btn btn-outline-primary rounded-pill btn-blue`}
                                    // data-bs-toggle="modal" data-bs-target="#templatePreviewForm"
                                    onClick={() => previewModal()}
                                >Preview</button>

                                <button type="button" className="btn btn-outline-primary rounded-pill btn-blue"
                                    // data-bs-dismiss="modal"
                                    // data-bs-toggle="modal" data-bs-target="#actionForm"
                                    // onClick={() => { setShowApprovalUserModal(true) }}
                                    onClick={() => { setShowTemplateModal(false); resetTemplate() }}
                                >Cancel</button>
                                <button type="button" className="btn btn-primary rounded-pill btn-blue"
                                    //  onClick={() => handleSubmit()} 
                                    // data-bs-dismiss="modal"
                                    onClick={() => { setShowTemplateModal(false); resetTemplate() }}
                                >Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {/* // New Function Modal // */}
            {/* <button data-bs-toggle="modal" data-bs-target="#emailTemplateForm">test</button> */}
            {/* email preview modal */}
            <div className="modal fade" id="templatePreviewForm" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="templatePreviewLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable com-details-form">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title fs-5" id="templatePreviewLabel">Preview</h5>
                        </div>
                        <div className="modal-body pb-0">
                            <div>{generateEmailHTML()}</div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-primary rounded-pill btn-blue"
                                data-bs-dismiss="modal"
                            // onClick={() => { setShowTemplateModal(false); resetTemplate() }}
                            >Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}
export default CreateWorkflow;